import React from 'react';
import "./Info.css";

function Info() {
  return (
    <section className='info'>
      <h2 className='info__title'>
        delicious food, delivered to you
      </h2>
      <p className="info__text">
        Choose your favorite meal from our broad selection of available meals and enjoy a delicious lunch or dinner at home.
      </p>
      <p className="info__text">
        All our meals are cooked with high-quality ingredients, just-in-time and of course by experienced chefs!
      </p>
    </section>
  )
}

export default Info
